module.exports = __webpack_public_path__ + "img/d7efeba.png";